/**
 * LOS NOMBRES DE AGRADECIMIENTOS.
 *
 * ⚠️ ARCHIVO GENERADO — no editar a mano.
 *     Se corrige en la TABLA DE TRADUCCIONES DE CANALIZADORES Y CANALIZADOS.xlsx
 *     y se regenera con:  python herramientas/nombres.py
 *
 * Faina, 26-ago: «se deben nombrar todos los canalizadores».
 *
 * ⚠️ ESTO INVIERTE LA POLITICA ANTERIOR de la pagina, que decia que NO se
 * nombraba a nadie sin permiso. El texto se cambio a la vez: la pagina no puede
 * decir una cosa y hacer otra. Nombrarlos EN AGRADECIMIENTOS es dar credito,
 * que es lo contrario de apropiarse.
 *
 * SIN EL NUMERO DE PIEZAS de cada uno, a proposito: un agradecimiento no es un
 * ranking. Hay quien aporto 973 cuerpos y quien aporto uno, y todos llevan la
 * misma linea.
 */

/* CUANTOS CANALIZADORES TIENE EL CORPUS — la cifra que se enseña en la web.
   Sale de contar la hoja «Canalizadores» de la tabla, y por eso SI incluye a
   Faina: es una estadistica del corpus estudiado, no la lista de a quien se
   agradece. La diferencia con CANALIZADORES.length es exactamente el (1). */
export const CANALIZADORES_DEL_CORPUS = 226;

/* Hoja «Canalizadores». Sin Faina, por decision suya (26-ago). */
export const CANALIZADORES = [
  "Abigail Caller",
  "Abigail Stellar",
  "Accord'Ange",
  "Adele Arini",
  "ÁhimRé",
  "Ailia Mira",
  "Alain Titeca",
  "Alexandra Solnado",
  "Alicia Sánchez",
  "Amada Selina",
  "Amanda Ellis",
  "Ana Dubois",
  "Ana Otero",
  "Anahi Rando",
  "Ángel Odeón",
  "Angélica Bovino",
  "Angelika Myriel di Bernardo",
  "Anja Camiaris von Oertzen",
  "Ann Albers",
  "Ann Dahlberg",
  "Anne Meurois-Givaudan",
  "Arthura Hector",
  "Asara Adams",
  "Barbara Manuela Herdle",
  "BDevine",
  "Bea Del Carmen",
  "Bea Gascón",
  "Beatrice Madsen",
  "Belén Sambucety",
  "Birgit Aulich",
  "Brandie Wells",
  "Brent Haskell",
  "Britta C. Delignat",
  "Carmen Hernández Rosety",
  "Carol Hermesh",
  "Carola Harter",
  "Carolina Díaz Chirón",
  "Caroline Oceana Ryan",
  "Carolyn Ann O'Riley",
  "Catalina Franco",
  "Cathelijne",
  "Cathy Thollois",
  "Celia Fenn",
  "Céline Vlaminck",
  "Charline Dumas",
  "Chellea Wilder",
  "Cindy Smith",
  "Claire Heartsong",
  "Claribel Puga",
  "Claudia Ferioli",
  "Cote Junemann",
  "Dancing Dolphin",
  "Daniel Meurois",
  "Daniel Scranton",
  "David Castillo",
  "Debbie Erasmus",
  "Deborah Faith",
  "Dianiluz Cora",
  "Digeón",
  "Dolores Cannon",
  "Dominique Vandenberghe",
  "Donna Frasca",
  "DoroTea",
  "Durga Holzhauser",
  "Elisa Staderini",
  "Elisabeth Giner",
  "Ellen Wouda",
  "Elsa Farrus",
  "Erena Velazquez",
  "Esencia Duše Sofia",
  "Esperanza Tovar",
  "Estella Maris",
  "Exequiel Barbatto",
  "Fabienne Laredo",
  "Finn Lorenzen",
  "Fran Zepeda",
  "Gabriela Strobl",
  "Gabriella Tuninetti",
  "Galaxygirl",
  "Genoveva Coyle",
  "Ghislaine Le Moine",
  "Gillian MacBeth-Louthan",
  "Gina Lake",
  "Glenda Green",
  "Goldenlight",
  "Grace LosAngelesytu",
  "Infiniti",
  "Isabel García",
  "Jabeen",
  "Jahn J. Kassl",
  "James McConnell",
  "James Tyberonn",
  "Jana Hillairet",
  "Jane Ribeiro",
  "Jayem",
  "Jelelle Awen",
  "Jennifer Crokaert",
  "Jennifer Hawkyard",
  "Jennifer Hoffman",
  "Jess Mangum",
  "Jesusschule",
  "Jill Cunningham",
  "Joan Walker",
  "Jocelyn Joy Thomas",
  "John Smallman",
  "Judith Coates",
  "Judith Dagley",
  "Jyotis",
  "Kai",
  "Karen Vivenzio",
  "Karolina Zamudio",
  "Kathleen Mary Willis",
  "Kátia de Souza",
  "Katy Simmone",
  "Kerstin Eriksson",
  "Keshavananda",
  "La Voce degli Angeli",
  "Laura Powers",
  "Laura Smith-Biswas",
  "Lea Chapin",
  "Lee Degani",
  "Leticia Breijo",
  "Linayah Kei Michael",
  "Linda Dillon",
  "Linda Robinson",
  "Lorena Cortondo",
  "Lorena Paz",
  "Louise Grant",
  "Luisa Macocchi",
  "Luz Campoy",
  "Lynette",
  "M. Fiter",
  "Maija Kadiķe",
  "Marcela Stachuza",
  "Marcos Astegiano",
  "Margarita González Pozuelo",
  "María Hartacho",
  "María Munay",
  "Maria Silvia Orlovas",
  "Marianne Ammann",
  "Mariarosa Gnudi",
  "Maribel Díaz de León",
  "Marie-Josée Andichou",
  "Marielle",
  "Marina Mares",
  "Marjoke de Grijs",
  "Marlene Swetlishoff",
  "Marta Povo",
  "Martha Gil",
  "Martine L'Équilibre",
  "Maryann Rada",
  "Mayuritzin",
  "Médium de Aviñón",
  "Melanie Beckler",
  "Mercè Carbonell",
  "Mercedes Kirkel",
  "Micaela Chichiraldi",
  "Michèle Lévy",
  "Milva Alpi",
  "Mónica Collantes",
  "Mónica Sánchez",
  "Nadia Aglianò",
  "Nadine Méjean",
  "Natalia Kuna",
  "Natalie Glasson",
  "Norma Gentile",
  "Octavia Vasile",
  "Pamela Kribbe",
  "Paola Burgos",
  "Patricia Casidis",
  "Patricia Iris Kerins",
  "Patricia Maureira",
  "Phillip Elton Collins",
  "Rachel Scoltock",
  "Rachele Camilla Frigerio",
  "Raquel Sánchez",
  "Regina Lawless",
  "Remedios Martínez",
  "Reniyah Wolf",
  "Rob Loveland",
  "Rodolfo Fuenzalida",
  "Ron Head",
  "Ronna",
  "Rui e Jéssica",
  "Saida Euali Arnaiz",
  "Samantha Páramo",
  "Sandra Gerez",
  "Sarah Hall",
  "Sayda Bulnes",
  "Shanta Gabriel",
  "Shauna Woods",
  "Shelley Young",
  "Shelly Dressel",
  "Silah Pere Sicart",
  "Snapdragon Tracy",
  "Sofie Ka",
  "Solange Marín",
  "Sonja Ariel von Staden",
  "Sophie Medium",
  "Soul Compass",
  "Stephan Davies",
  "Steve Rother",
  "Susana Duarte Antunes",
  "Sylvain Didelot",
  "Taryn Crimi",
  "Tatiana Nieto",
  "Tetsiea",
  "Ti degli Arcangeli",
  "Tina Louise Spalding",
  "Tôma",
  "Trine Lund Kjær",
  "Um Toque Colibri",
  "Ute Posegga-Rudel",
  "Valeria Pérez",
  "Vanessa Louchart",
  "Vanessa Stewart",
  "Vania Rodrigues",
  "Vannia Canaldeluz",
  "Verónica Fernández",
  "Victoria Cochrane",
  "Virginie Sophia",
  "Wayne McDonald",
  "Wendy Ann Zellea",
  "Will Caminada",
  "Xavier Pedro Gallego"
];

/* Hoja «Otros» — quienes nos despertaron. */
export const DESPERTARON = [
  "Chaca",
  "Cote Junemann",
  "Gabriela Pavez",
  "Javiera Diaz",
  "Kika",
  "Maria Ignacia Herrera"
];

/* Hoja «Cantantes» — quienes nos conectan con las voces. Salen de las tres
   listas de Spotify de la Fundacion (MoM, Mantras y Meditations); sus canciones
   estan en la hoja «Canciones» de la TABLA DE MUSICA.xlsx, que se pone al dia
   con SCRIPTS/_tabla_musica.py --actualizar (la lista de Spotify se mueve sola:
   el 28-ago eran 396 canciones, el 9-sep 366). */
export const CANTANTES = [
  "Aaron Martin",
  "Abel Korzeniowski",
  "Aghapy",
  "Ahmed El-Eshmer",
  "Ajeet",
  "Alan Silvestri",
  "Alejandro Karo",
  "Alexios Anest",
  "Alexis Ffrench",
  "Alice Sara Ott",
  "Amaranth Cove",
  "Amrit Kirtan",
  "Ana Alcaide",
  "André Maris",
  "Andrea Vanzo",
  "Andy Barlow",
  "Angus MacRae",
  "Anna Golden",
  "Aodhán King",
  "Ariztía",
  "Ashana",
  "Audrey Assad",
  "Bear McCreary",
  "Ben Russell",
  "Benjamin Gustafsson",
  "Benjamin Wallfisch",
  "Benjy Wertheimer",
  "Bethel Music",
  "Bon Vie",
  "Borrtex",
  "Brambles",
  "Brasstríó Mosfellsdals",
  "Breton Vivian",
  "Brian Crain",
  "Brian Eno",
  "Brian McBride",
  "Brian Tyler",
  "Capital City Music",
  "Cesar Benito",
  "Chad Lawson",
  "Charis Studio",
  "Charity Gayle",
  "Chris Bleth",
  "Chris Worsey",
  "Clarice Jensen",
  "Clem Leek",
  "Clint Eastwood",
  "Clint Mansell",
  "Coalo Zamorano",
  "Craig Armstrong",
  "Danielle Rose",
  "Danny Elfman",
  "Dario Marianelli",
  "Deuter",
  "Deva Premal",
  "Dimash Qudaibergen",
  "Dion Davis",
  "Dirk Maassen",
  "Don Davis",
  "Dustin O'Halloran",
  "Edith Whiskers",
  "Edo",
  "Edo & Jo",
  "Eliza King",
  "Elohim Songs",
  "Emmy Rose",
  "English Chamber Orchestra",
  "Ennio Morricone",
  "Enzo",
  "Essie Jain",
  "Esther Yoo",
  "Eydís Evensen",
  "Fabrizio Paterlini",
  "Federico Albanese",
  "Fernando Velázquez",
  "Finneas O'Connell",
  "Franni Cash",
  "Gabríel Ólafs",
  "Gabriel Yared",
  "Gan-ya Ben-gur Akselrod",
  "Garth Stevenson",
  "Gavin Greenaway",
  "Gavin Luke",
  "Geek Music",
  "Gibran Alcocer",
  "Gotama",
  "GuruGanesha Singh",
  "Guy Farley",
  "Hammock",
  "Hania Rani",
  "Hans Zimmer",
  "Harold Budd",
  "Harold Faltermeyer",
  "Hildur Guðnadóttir",
  "Hillside Recording",
  "Hillsong Young & Free",
  "Hollywood Studio Symphony",
  "Howard David Blake",
  "Hushed",
  "Igor Krutoy",
  "Illuminine",
  "James Fitzpatrick",
  "James Heather",
  "James Horner",
  "James Southall",
  "Jane Winther",
  "Janin Devi",
  "Jaraneh Nova",
  "Jay Ungar",
  "Jean-Philippe Rameau",
  "Jeremy Riddle",
  "Jesús Adrián Romero",
  "Jesús Cabello",
  "Joan Manuel Serrat",
  "Joe Alexander Shepherd",
  "Joep Beving",
  "Jóhann Jóhannsson",
  "Johannes Bornlöf",
  "John Barry",
  "John De Kadt",
  "John Debney",
  "John Metcalfe",
  "Jon Hopkins",
  "Jordan Critz",
  "Jordan S. Mompo",
  "Jorge Sachez",
  "Juan Luis Guerra 4.40",
  "Juan Susarte & Confia2",
  "Karuna",
  "Kazu Matsui",
  "Kevin James",
  "Krishna Das",
  "Kristene DiMarco",
  "Leeland",
  "Lennie Niehaus",
  "Lenzspot",
  "Liquid Mind",
  "Living",
  "Lluis Martinez Ten",
  "London Symphony Orchestra",
  "Lotus Gate – Buddhist Music",
  "Louisa Fuller",
  "Lucas Consuegra",
  "Ludovico Einaudi",
  "Luke Howard",
  "Maggie Boyle",
  "Maite López",
  "Majo y Dan",
  "Manish Vyas",
  "Marcela Gandara",
  "Marcos Vidal",
  "Matthew Schoening",
  "Mattia Vlad Morleo",
  "Max Richter",
  "Maxence Cyrin",
  "Melannie Betancourth",
  "Michael Nyman",
  "Michele McLaughlin",
  "Mike Taylor",
  "Mirabai Ceiba",
  "Miranda y Tobar",
  "Miten",
  "Mooji",
  "Mooji Mala",
  "Moux",
  "Natalia Bonner",
  "Natalie Grace",
  "Nawang Khechog",
  "Nessi Gomes",
  "Nick Ingman",
  "Nick Ingman & His Orchestra",
  "Niklas Paschburg",
  "Nils Frahm",
  "Nirinjan Kaur",
  "Odessa Orchestra & Friends",
  "Ólafur Arnalds",
  "Olivia Belli",
  "Omkara",
  "Paul Bateman",
  "Peter Broderick",
  "Peter Gregson",
  "Peter Kater",
  "Peter Sandberg",
  "Philip Sheppard",
  "Phoria",
  "Rachel Jacques",
  "Rachel Portman",
  "Ram Dass",
  "Rand Aldo",
  "Roger Kellaway",
  "Ron Allen",
  "Royal Philharmonic Orchestra",
  "Sacred Earth",
  "Secret Garden",
  "Shankar and Gingger",
  "Shannon Kingsbury",
  "Shantala",
  "Shimshai",
  "Sigur Rós",
  "Simeon Walker",
  "Singh Kaur",
  "Slow Meadow",
  "Snatam Kaur",
  "Sophie Hutchings",
  "Stars Of The Lid",
  "Stephan Moccio",
  "Steven Musso",
  "Syml",
  "Tanya Tsarouska",
  "Tarn Travers",
  "Taya",
  "The City of Prague Philharmonic Orchestra",
  "The London Studio Symphony Orchestra",
  "Thomas Barquee",
  "Thomas Pasatieri",
  "Tina Malia",
  "Tony Anderson",
  "Tony Ann",
  "Tony Hinnigan",
  "Trevor Hall",
  "Trevor Kowalski",
  "Trevor Morris",
  "Un Corazón",
  "Valentina Lisitsa",
  "Verónica Sanfilippo",
  "Vic Frasier",
  "Víkingur Ólafsson",
  "Voces8",
  "We The Kingdom",
  "Whitney Houston",
  "Wouter Dewit",
  "Xavier Rudd",
  "Yanni",
  "Yiruma",
  "Yuki Numata Resnick"
];
